/**
 * TypeScript types for cursor sharing events in v2
 */

export interface CursorPosition {
  x: number; // Normalized coordinate [0,1]
  y: number; // Normalized coordinate [0,1]
  participantId: string;
  timestamp: number;
}

export interface VideoBounds {
  top: number;
  left: number;
  width: number;
  height: number;
}

export interface CursorMoveEvent {
  type: 'cursor_move';
  position: CursorPosition;
  coordinateSystem: 'normalized';
  videoBounds: VideoBounds | null;
  shareId: string;
}

export interface CursorClickEvent {
  type: 'cursor_click';
  position: CursorPosition;
  coordinateSystem: 'normalized';
  videoBounds: VideoBounds | null;
  shareId: string;
}

export interface CursorDragEvent {
  type: 'cursor_drag';
  startPosition: CursorPosition;
  endPosition: CursorPosition;
  coordinateSystem: 'normalized';
  videoBounds: VideoBounds | null;
  shareId: string;
}

export interface CursorDragStartEvent {
  type: 'cursor_drag_start';
  position: CursorPosition;
  coordinateSystem: 'normalized';
  videoBounds: VideoBounds | null;
  shareId: string;
}

export interface CursorDragEndEvent {
  type: 'cursor_drag_end';
  startPosition: CursorPosition;
  endPosition: CursorPosition;
  coordinateSystem: 'normalized';
  videoBounds: VideoBounds | null;
  shareId: string;
}

export type CursorEvent =
  | CursorMoveEvent
  | CursorClickEvent
  | CursorDragEvent
  | CursorDragStartEvent
  | CursorDragEndEvent;

// Helper function to create cursor move event
export function createCursorMoveEvent(
  position: CursorPosition,
  videoBounds: VideoBounds | null,
  shareId: string,
): CursorMoveEvent {
  return {
    type: 'cursor_move',
    position,
    coordinateSystem: 'normalized',
    videoBounds,
    shareId,
  };
}

// Helper function to create cursor click event
export function createCursorClickEvent(
  position: CursorPosition,
  videoBounds: VideoBounds | null,
  shareId: string,
): CursorClickEvent {
  return {
    type: 'cursor_click',
    position,
    coordinateSystem: 'normalized',
    videoBounds,
    shareId,
  };
}

// Helper function to create cursor drag start event
export function createCursorDragStartEvent(
  position: CursorPosition,
  videoBounds: VideoBounds | null,
  shareId: string,
): CursorDragStartEvent {
  return {
    type: 'cursor_drag_start',
    position,
    coordinateSystem: 'normalized',
    videoBounds,
    shareId,
  };
}

// Helper function to create cursor drag event
export function createCursorDragEvent(
  startPosition: CursorPosition,
  endPosition: CursorPosition,
  videoBounds: VideoBounds | null,
  shareId: string,
): CursorDragEvent {
  return {
    type: 'cursor_drag',
    startPosition,
    endPosition,
    coordinateSystem: 'normalized',
    videoBounds,
    shareId,
  };
}

// Helper function to create cursor drag end event
export function createCursorDragEndEvent(
  startPosition: CursorPosition,
  endPosition: CursorPosition,
  videoBounds: VideoBounds | null,
  shareId: string,
): CursorDragEndEvent {
  return {
    type: 'cursor_drag_end',
    startPosition,
    endPosition,
    coordinateSystem: 'normalized',
    videoBounds,
    shareId,
  };
}
